import React from 'react';
import { Modal } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import type { TFunction } from 'i18next';

interface OnlineConfirmOptions {
    t: TFunction;
    name: string;
    /** yyyy-MM-dd，美西 */
    startDate?: string | null;
    /** yyyy-MM-dd HH:mm，美西；不需报名时为空 */
    signUpDeadline?: string | null;
    onOk: () => Promise<void> | void;
}

/**
 * 上线确认弹窗（原型页面 4）：展示活动开始时间、报名截止时间，红字提示上线后基本信息 / 参与条件 / 活动规则不可修改。
 */
export function confirmOnline({ t, name, startDate, signUpDeadline, onOk }: OnlineConfirmOptions): void {
    Modal.confirm({
        width: 460,
        icon: <ExclamationCircleFilled style={{ color: '#FAAD14' }} />,
        title: <span className="text-[17px]">{t('driverOps.activity.onlineConfirm.title')}</span>,
        okText: t('driverOps.activity.onlineConfirm.ok'),
        cancelText: t('common.cancel'),
        onOk,
        content: (
            <div className="text-[14px] text-[#595959] leading-[1.7]">
                <div className="mb-[10px]">{t('driverOps.activity.onlineConfirm.intro', { name })}</div>
                <div className="border border-[#D9CCFF] rounded-lg bg-[#FBF9FF]">
                    <div className="px-[14px] py-[10px] border-b border-[#EAE2FF]">
                        <div className="text-[13px] text-[#595959] mb-[2px]">{t('driverOps.activity.onlineConfirm.startTime')}</div>
                        <div className="font-semibold text-[#1F1F1F] leading-[1.6]">
                            <span className="text-[20px] font-bold text-[#722ed1]">{startDate ? `${startDate} 00:00` : '--'}</span>
                            <span className="text-[#8C8C8C] text-[12.5px] ml-[6px]">
                                {t('driverOps.activity.form.monday')} · {t('driverOps.activity.form.timeZoneShort')}
                            </span>
                        </div>
                    </div>
                    <div className="px-[14px] py-[10px] border-b border-[#EAE2FF]">
                        <div className="text-[13px] text-[#595959] mb-[2px]">{t('driverOps.activity.onlineConfirm.signUpDeadline')}</div>
                        <div className="font-semibold text-[#1F1F1F] leading-[1.6]">
                            {signUpDeadline || t('driverOps.activity.onlineConfirm.noSignUp')}
                        </div>
                    </div>
                    <div className="px-[14px] py-[10px] font-semibold text-[#F0453A] leading-[1.6]">
                        {t('driverOps.activity.onlineConfirm.lockedHint')}
                    </div>
                </div>
            </div>
        ),
    });
}
